import { ChangeDetectorRef, Component, OnInit, ViewChild, effect, inject, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EnumService } from '../../../services/enum.service';
import { BreadcrumbService, EnumValues, ModalService, Note, NotesSidebarComponent, EnumObjectExtended } from '@card-software/library';
import { UserLite } from '../../../models/user-master/user-lite';

import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs';

import { Fabric } from '../../../models/item/fabric';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import _ from 'lodash';
import { FabricProxyService } from '../../../proxies/item/fabric.proxy.service';
import {
  CustomerProductOrders,
  YearWeek,
  WorkOrder,
  WorkOrderFabric,
  WorkOrderSearchCommand,
  WorkOrderType,
} from '../../../models/order/work-order';
import { setOptionsForPrimeNg } from '../../../PrimeNG/utils';
import moment from 'moment';
import { Calendar } from 'primeng/calendar';
import { DyeingColor } from '../../../models/item/lab-dip';
import { LabDipRequestProxyService } from '../../../proxies/item/lab-dip-request-proxy.service';
import { Address } from '../../../models/finance/address';
import { ConfirmationService, MessageService } from 'primeng/api';
import { UserAuthenticationService } from '../../../services/user-authentication.service';
import { WorkOrderReportService } from '../../../services/work-order-report.service';
import { BusinessProxyService } from '../../../proxies/finance/business.proxy.service';
import { BusinessEntityType } from '../../../models/business-type-entities';
import { GlobalMessageUtil } from '@card-software/nexus-utilities';
import { Business } from '../../../models/finance/business';
import { YarnQuantityUtil } from '../../../utilities/yarn-quantity.util';
import { WorkOrderRoles } from '../../../models/roles/roles-group';
import { CompositionProxyService } from '../../../proxies/item/composition-proxy.service';
import { Composition } from '../../../models/yarn/composition';
import { CertificationProxyService } from '../../../proxies/item/certification-proxy.service';
import { Certification } from '../../../models/item/item-master/item-master';
import { WorkOrderProxyService } from '../../../proxies/order/work-order.proxy.service';
import { ProductDevelopmentStatus } from '../../../models/item/enum/product-development-status';
import { AuthService } from '@card-software/nexus-utilities';

export interface WorkOrderFabricFormGroup {
  fabricCode: FormControl<string>;
  fabric: FormControl<Fabric | null>;
  aliases?: FormGroup<{
    customerReference: FormControl<string | null>;
    alias: FormControl<string | null>;
  }>;
  packingType: FormControl<number | null>;
  clientRequestedFabricLabelCode: FormControl<string | null>;
  unitPrice: FormControl<number>;
  quantityInUOM: FormControl<number>;
  garmetPart: FormControl<number | null>;
  garmetDetails: FormArray<FormGroup<GarmentDetailForm>>;
  yarnCertificationDetails: FormArray<FormGroup<YarnCertificationDetailsForm>>;
  aliasReference?: FormControl<string | null>;
  productOrderNumber?: FormControl<string | null>;
}

export interface GarmentDetailForm {
  colorReference: FormControl<string>;
  quantity: FormControl<number>;
  productOrderNumber: FormControl<string | null>;
  unitPrice: FormControl<number>;
}

export interface YarnCertificationDetailsForm {
  yarnCode: FormControl<string>;
  certificationReferences: FormControl<string[]>;
}

export enum YarnOrigin {
  CAFTA = 0,
  Asia = 1,
}

@Component({
  selector: 'app-work-order-details',
  templateUrl: './work-order-details.component.html',
  styleUrl: './work-order-details.component.scss',
})
export class WorkOrderDetailsComponent implements OnInit {
  isLoading = 0;
  firstLoad = signal(true);
  isUpdatingFromServer = signal(false);
  workOrder: WorkOrder | null = null;
  orderType = 0;
  planningEstimatedWeekNumber = 0;
  estimatedShipmentWeekNumber = 0;
  selectedUomLabel = '';
  filteredFabrics: Fabric[] = [];
  fabrics: Fabric[] = [];
  filteredCustomers: Business[] = [];
  filteredBrands: Business[] = [];
  filteredAddresses: Address[] = [];
  customerAddresses: Address[] = [];
  allCompositions: Composition[] = [];
  certifications: Certification[] = [];
  userLite: UserLite | null;
  isShortFall = false;

  billingSameAsClient = new FormControl<boolean>(false, { nonNullable: true });
  shippingSameAsBilling = new FormControl<boolean>(false, { nonNullable: true });
  // Enums
  WorkOrderType = WorkOrderType;
  public statusEnums: EnumValues = {};
  public statusEnumObject?: EnumObjectExtended;
  public orderTypesEnums: EnumValues = {};
  public unitOfMeasurementEnums: EnumValues = {};
  public workOrderTermEnums: EnumValues = {};
  public shipmentTypeEnums: EnumValues = {};
  public yarnOriginEnums: EnumValues = {};
  public packingTypeEnums: EnumValues = {};
  // Simple yarn origin options
  yarnOriginOptions = [
    { label: 'CAFTA', value: 0 },
    { label: 'Asia', value: 1 },
  ];
  // Forms and Controls
  specificWorkOrderGreige = new FormControl<WorkOrder | null>(null);
  customerShippingAddress = new FormControl<Address | null>(null);
  totalFabricQuantity = new FormControl({ value: 0, disabled: true });
  totalYarnQuantity = new FormControl({ value: 0, disabled: true });

  //Date fields
  productOrderNumberDateReceived = new FormControl<Date | null>(null);
  yarnLatestReceptionDate = new FormControl<Date | null>(null);
  knittingLatestStartDate = new FormControl<Date | null>(null);
  knittingEstimatedEndDate = new FormControl<Date | null>(null);
  dyeingLatestStartDate = new FormControl<Date | null>(null);
  dyeingEstimatedEndDate = new FormControl<Date | null>(null);
  finishingLatestStartDate = new FormControl<Date | null>(null);
  finishingEstimatedEndDate = new FormControl<Date | null>(null);
  promisedShipmentDate = new FormControl<Date | null>(null);

  productOrderNumber = new FormControl('');
  clientOrderReference = new FormControl('');
  status = new FormControl(0, [Validators.required]);
  orderDetailsForm: FormGroup;
  orderAuditTrailForm: FormGroup;
  // greigeWorkOrderToUse = new FormControl<WorkOrder | null>(null);
  orderDetailsFormSubmitted = false;
  // Inputs Ref
  @ViewChild('planningEstimatedInput') planningEstimatedInput!: Calendar;
  @ViewChild('estimatedShipmentInput') estimatedShipmentInput!: Calendar;

  shippingToOptions: Business[] = [];
  billingToOptions: Business[] = [];

  customerColors: DyeingColor[] = [];
  workOrderFabricFormArrays: FormArray<FormGroup<WorkOrderFabricFormGroup>> = new FormArray<FormGroup<WorkOrderFabricFormGroup>>([]);

  setOptionsForPrimeNg = setOptionsForPrimeNg;
  customerProductOrders: CustomerProductOrders[] = [];
  notes: Note[] = [];

  greigeWorkOrderSuggestions: WorkOrder[] = [];

  get shippingToName() {
    return this.billingSameAsClient.value ? this.orderDetailsForm.value.customer?.name : this.orderDetailsForm.value.billingTo?.name;
  }

  get shippingToCode() {
    return this.billingSameAsClient.value ? this.orderDetailsForm.value.customer?.code : this.orderDetailsForm.value.billingTo?.code;
  }

  get fabricPoundsQuantity() {
    if (this.orderDetailsForm.value.uom === 3) {
      return this.totalFabricQuantity.value;
    }
    let totalFabricQuantity = 0;
    this.workOrderFabricFormArrays.controls.forEach((fabricForm) => {
      const quantity = fabricForm.get('quantityInUOM')?.value;
      if (quantity) {
        totalFabricQuantity += quantity / (fabricForm.get('fabric')?.value?.poundToYard ?? 0) || 0;
      }
    });
    return +totalFabricQuantity.toFixed(2);
  }

  get fabricYardsQuantity() {
    if (this.orderDetailsForm.value.uom === 5) {
      return this.totalFabricQuantity.value;
    }
    let totalFabricQuantity = 0;
    this.workOrderFabricFormArrays.controls.forEach((fabricForm) => {
      const quantity = fabricForm.get('quantityInUOM')?.value;
      if (quantity) {
        totalFabricQuantity += quantity * (fabricForm.get('fabric')?.value?.poundToYard ?? 1) || 0;
      }
    });
    return +totalFabricQuantity.toFixed(2);
  }

  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private workOrderProxyService = inject(WorkOrderProxyService);
  private enumService = inject(EnumService);
  private fabricProxyService = inject(FabricProxyService);
  private businessProxyService = inject(BusinessProxyService);
  private fb = inject(FormBuilder);
  private cRef = inject(ChangeDetectorRef);
  private labDipRequestProxyService = inject(LabDipRequestProxyService);
  private messageService = inject(MessageService);
  private userAuthenticationService = inject(UserAuthenticationService);
  private workOrderReportService = inject(WorkOrderReportService);
  private compositionProxyService = inject(CompositionProxyService);
  private certificationProxyService = inject(CertificationProxyService);
  private modalService = inject(ModalService);
  private confirmationService = inject(ConfirmationService);
  private breadcrumbService = inject(BreadcrumbService);

  constructor() {
    this.userLite = this.userAuthenticationService.userLite;

    // set enums
    effect(() => {
      this.statusEnumObject = this.enumService.getEnum('WorkOrderStatus', 'orderEnums');
      this.statusEnums = this.statusEnumObject?.values ?? {};
      this.orderTypesEnums = this.enumService.getEnum('WorkOrderType', 'orderEnums')?.values;
      this.unitOfMeasurementEnums = this.enumService.getEnum('UnitOfMeasure', 'itemEnums')?.values;
      // Filter unitOfMeasurementEnums by LB and yard
      Object.keys(this.unitOfMeasurementEnums).forEach((key) => {
        if (Number(key) != 3 && Number(key) != 5) delete this.unitOfMeasurementEnums[Number(key)];
      });

      this.workOrderTermEnums = this.enumService.getEnum('WorkOrderTerm', 'orderEnums')?.values;
      this.shipmentTypeEnums = this.enumService.getEnum('ShipmentType', 'orderEnums')?.values;
      this.packingTypeEnums = this.enumService.getEnum('PackingType', 'orderEnums')?.values;
      this.filterTermsBasedOnOrderType(this.orderType);
    });
    // set forms
    this.orderDetailsForm = this.fb.group({
      id: new FormControl(''),
      orderType: new FormControl({ value: this.orderType, disabled: true }, [Validators.required]),
      workOrderTerm: new FormControl(null, [Validators.required]),
      uom: new FormControl(null, [Validators.required]),
      customerReference: new FormControl('', [Validators.required]),
      customer: new FormControl<Business | null>(null),
      negotiatiedLeadTimeInWeeks: new FormControl(0),
      orderReceivedDate: new FormControl(new Date(), [Validators.required]),
      actualShipmentDate: new FormControl(new Date()),
      shipmentType: new FormControl(null, [Validators.required]),
      brandReference: new FormControl('', [Validators.required]),
      brand: new FormControl<Business | null>(null),
      planningEstimatedYW: new FormControl<Date | YearWeek | string | null>(null),
      estimatedShipmentDate: new FormControl<Date | string | null>(null),
      billingTo: new FormControl<Business | null>(null),
      billingAddressCode: new FormControl<number | null>(null),
      paymentTermsClientCode: new FormControl<string | null>(null, [Validators.required]),
      shippingTo: new FormControl<Business | null>(null),
      shippingAddressCode: new FormControl<number | null>(null),
      yarnOrigin: new FormControl<number | null>(null),
    });

    this.orderAuditTrailForm = this.fb.group({
      createdBy: new FormControl({ value: '', disabled: true }),
      createdDate: new FormControl({ value: new Date(), disabled: true }),
      modifiedBy: new FormControl({ value: '', disabled: true }),
      modifiedDate: new FormControl({ value: new Date(), disabled: true }),
    });
  }

  canEdit() {
    // if Admin or Editor
    if (AuthService.hasRole(WorkOrderRoles.WorkOrderAdmin) || AuthService.hasRole(WorkOrderRoles.WorkOrderEditor)) {
      return true;
    }
    // if Viewer
    if (AuthService.hasRole(WorkOrderRoles.WorkOrderViewer)) {
      return false;
    }
    // Default
    return false;
  }

  ngOnInit(): void {
    this.status.valueChanges.subscribe((value) => {
      if (!_.isNil(value) && value >= 2 && !this.firstLoad() && !this.isUpdatingFromServer()) {
        this.confirmationService.confirm({
          key: 'main',
          message: 'Are you sure you want to change the status?',
          accept: () => {
            this.isLoading++;
            this.workOrderProxyService
              .updateStatus(this.workOrder!.id!, value.toString())
              .pipe(
                finalize(() => {
                  this.isLoading--;
                }),
              )
              .subscribe({
                next: (response) => {
                  if (response.success) {
                    // this.isLoading--;
                    GlobalMessageUtil.success('Success', `Work Order status updated to ${this.statusEnums[value]}`);
                    this.isUpdatingFromServer.set(true);
                    this.getWorkOrderById(this.workOrder!.id!, false);
                  }
                },
                error: () => {
                  // this.isLoading--;
                  this.status.setValue(this.workOrder?.status ?? 0, { emitEvent: false });
                },
              });
          },
          reject: () => {
            // this.isLoading--;
            this.status.setValue(this.workOrder?.status ?? 0, { emitEvent: false });
          },
        });
      }
    });
    // Get work order based on query param id
    this.route.queryParams.subscribe((params) => {
      const id = params['id'];
      const isCopy = params['isCopy'] === 'true';
      const isShortFall = params['isShortFall'] === 'true';
      if (!id) {
        this.router.navigate(['/work-orders']);
        return;
      }

      if (id === 'new') {
        this.breadcrumbService.setCurrent('Common_New');
        this.orderType = Number(params['orderType']);
        this.filterTermsBasedOnOrderType(this.orderType);
        this.orderDetailsForm.patchValue({ orderType: this.orderType });
      } else if (isShortFall) {
        this.isLoading++;
        this.getWorkOrderById(id, false, isShortFall);
        this.isShortFall = true;
      } else {
        this.isLoading++;
        this.getWorkOrderById(id, isCopy);
      }

      // In both new/edit, if orderType is Linked disable uom & brand
      if (this.orderDetailsForm.get('orderType')!.value === WorkOrderType.Linked) {
        this.orderDetailsForm.get('uom')!.disable();
        this.orderDetailsForm.get('brand')!.disable();
      }
    });

    this.compositionProxyService.getAllCompositions().subscribe({
      next: (response) => {
        this.allCompositions = response.data ?? [];
      },
      error: (error) => {
        console.error('Error fetching compositions:', error);
        this.allCompositions = [];
      },
    });

    this.certificationProxyService.getAllCertifications().subscribe({
      next: (response) => {
        this.certifications = response.data ?? [];
      },
      error: (error) => {
        console.error('Error fetching certifications:', error);
        this.certifications = [];
      },
    });

    this.orderDetailsForm.get('customerReference')?.valueChanges.subscribe((value) => {
      if (value) {
        this.labDipRequestProxyService.getCustomerColors(value).subscribe({
          next: (response) => {
            this.customerColors = response.data ?? [];
          },
          error: (e) => {
            console.error(e);
          },
          complete: () => {
            this.firstLoad.set(false);
          },
        });
      }
    });

    this.workOrderFabricFormArrays.valueChanges.subscribe(() => {
      // Calculate total fabric quantity
      let totalFabricQuantity = 0;
      let yarnTotalQuantity = 0;
      this.workOrderFabricFormArrays.controls.forEach((fabricForm) => {
        const quantity = fabricForm.get('quantityInUOM')?.value;
        if (quantity) {
          totalFabricQuantity += quantity;
          const yarnQuantity = YarnQuantityUtil.calculateYarnQuantity({
            quantityInUOM: quantity,
            uom: this.orderDetailsForm.value.uom,
            fabric: fabricForm.get('fabric')?.value ?? null,
            orderType: this.orderDetailsForm.getRawValue().orderType,
          });
          yarnTotalQuantity += yarnQuantity;
        }
      });
      this.totalFabricQuantity.setValue(totalFabricQuantity);
      this.totalYarnQuantity.setValue(yarnTotalQuantity);
    });
    //Disable form by Rol
    if (!this.canEdit()) {
      this.orderDetailsForm.disable();
      this.productOrderNumber.disable();
      this.clientOrderReference.disable();
      this.productOrderNumberDateReceived.disable();
      this.billingSameAsClient.disable();
      this.totalFabricQuantity.disable();
      this.totalYarnQuantity.disable();
      this.yarnLatestReceptionDate.disable();
      this.knittingLatestStartDate.disable();
      this.knittingEstimatedEndDate.disable();
      this.dyeingLatestStartDate.disable();
      this.dyeingEstimatedEndDate.disable();
      this.finishingLatestStartDate.disable();
      this.finishingEstimatedEndDate.disable();
      this.promisedShipmentDate.disable();
      this.specificWorkOrderGreige.disable();
      this.shippingSameAsBilling.disable();
    }

    // Disable payment terms input
    this.orderDetailsForm.get('paymentTermsClientCode')?.disable();
  }

  filterAddresses(addresses: Address[], addressType: number): Address[] {
    if (!addresses || addresses.length === 0) return [];

    return addresses
      .filter((address) => address.addressTypes.includes(addressType))
      .map((address) => ({
        ...address,
        fieldToDisplay:
          `(${address.code}) ${address.address1} ${address.address2 || ''} ${address.city} ${address.zipCode} ${address.country}`.trim(),
        code: address.code,
      }));
  }

  printWorkOrderReport() {
    if (this.workOrder?.id) {
      this.workOrderReportService.generatePdfReport(this.workOrder.id);
    } else {
      GlobalMessageUtil.error('Error', 'Work Order ID is not available for report generation.');
    }
  }

  private setupCustomerAddresses(customer: Business, shippingAddressCode?: number): void {
    if (!customer || !customer.addresses) return;

    const addressesWithDisplay = customer.addresses.map((address: Address) => ({
      ...address,
      fieldToDisplay: `(${address.code}) ${address.address1} ${address.address2} ${address.city} ${address.zipCode} ${address.country}`,
    }));

    this.customerAddresses = addressesWithDisplay.filter((a) => a.addressTypes.includes(1));

    // Configurar la dirección seleccionada
    if (shippingAddressCode) {
      const selected = this.customerAddresses.find((a) => a.code === shippingAddressCode);
      if (selected) {
        this.customerShippingAddress.setValue(selected);
      }
    }
  }
  getCustomerById(id: string, shippingAddressCode?: number) {
    this.businessProxyService.getById(id).subscribe((res) => {
      const customerList = res.data;

      if (Array.isArray(customerList) && customerList.length > 0) {
        const customer = customerList[0];

        // Actualizar el customer en el formulario
        this.orderDetailsForm.patchValue({ customer });

        // Configurar las addresses
        this.setupCustomerAddresses(customer, shippingAddressCode);
      }
    });
  }

  onSelectGreigeWorkOrderToUse(event: AutoCompleteSelectEvent) {
    this.specificWorkOrderGreige.setValue(event.value);
    const greigeWorkOrder: WorkOrder = event.value;
    this.orderDetailsForm.patchValue({
      specificWorkOrderGreigeReference: greigeWorkOrder.id,
      negotiatiedLeadTimeInWeeks: greigeWorkOrder.negotiatiedLeadTimeInWeeks,
      customer: greigeWorkOrder.customer,
      customerReference: greigeWorkOrder.customerReference,
      brandReference: greigeWorkOrder.brandReference,
      uom: greigeWorkOrder.uom,
      brand: greigeWorkOrder.brand,
    });

    // clear workOrderFabricFormArrays
    this.workOrderFabricFormArrays.clear();
    // get and push greigeWorkOrder fabrics
    if ((greigeWorkOrder?.id && this.workOrder?.fabrics.length === 0) || !this.workOrder) {
      greigeWorkOrder.fabrics.forEach((fabric) => {
        const yarnCertificationDetailsArray = !_.isNil(fabric.yarnCertificationDetails)
          ? new FormArray<FormGroup<YarnCertificationDetailsForm>>(
              fabric.fabric?.greige?.yarnDetails.map((yarnDetails) =>
                this.fb.group<YarnCertificationDetailsForm>({
                  yarnCode: new FormControl(yarnDetails.yarnCode!, { nonNullable: true }),
                  certificationReferences: new FormControl(
                    fabric.yarnCertificationDetails?.find((yc) => yc.yarnCode === yarnDetails.yarnCode)?.certificationReferences || [],
                    { nonNullable: true },
                  ),
                }),
              ),
            )
          : new FormArray<FormGroup<YarnCertificationDetailsForm>>(
              fabric.fabric?.greige?.yarnDetails.map((yarnDetails) =>
                this.fb.group<YarnCertificationDetailsForm>({
                  yarnCode: new FormControl(yarnDetails.yarnCode!, { nonNullable: true }),
                  certificationReferences: new FormControl([], { nonNullable: true }),
                }),
              ),
            );
        const garmetDetailsArray = new FormArray<FormGroup<GarmentDetailForm>>([]);
        const fabricForm = new FormGroup<WorkOrderFabricFormGroup>({
          fabricCode: new FormControl(fabric.fabricCode, { nonNullable: true }),
          fabric: new FormControl(fabric.fabric),
          packingType: new FormControl(fabric.packingType, { validators: [Validators.required], nonNullable: true }),
          clientRequestedFabricLabelCode: new FormControl(fabric.clientRequestedFabricLabelCode || null),
          unitPrice: new FormControl(fabric.unitPrice ?? 0, { validators: [Validators.required, Validators.min(0.01)], nonNullable: true }),
          garmetPart: new FormControl(fabric.garmetPart, { validators: [Validators.required], nonNullable: true }),
          quantityInUOM: new FormControl(fabric.quantityInUOM, {
            validators: [Validators.required, Validators.min(0.01)],
            nonNullable: true,
          }),
          garmetDetails: garmetDetailsArray,
          yarnCertificationDetails: yarnCertificationDetailsArray,
          productOrderNumber: new FormControl(fabric.productOrderNumber || null, { nonNullable: true }),
          aliasReference: new FormControl(fabric.aliasReference || null, { nonNullable: true }),
        });

        this.workOrderFabricFormArrays.push(fabricForm);
      });
    }
  }

  filterTermsBasedOnOrderType(orderType: number) {
    switch (orderType) {
      case 0:
        //Sample: no enums are deleted
        break;
      case 1:
        //Bulk: no enums are deleted
        break;
      case 2:
        //GreigeStockForDyeing: keep only CommissionKnitting, FullKnitting (delete 2,3,4,5)
        Object.keys(this.workOrderTermEnums).forEach((key) => {
          if (Number(key) == 2 || Number(key) == 3 || Number(key) == 4 || Number(key) == 5) delete this.workOrderTermEnums[Number(key)];
        });
        break;
      case 3:
        //ShortFall: no enums are deleted
        break;
      case 4:
        //Linked: keep only Dyeing, FullPackage, CommissionKnittingAndDyeing (delete 0,1,5)
        Object.keys(this.workOrderTermEnums).forEach((key) => {
          if (Number(key) == 0 || Number(key) == 1 || Number(key) == 5) delete this.workOrderTermEnums[Number(key)];
        });
        break;
      case 5:
        //BGrade: keep only BGrade term (value 5) (delete 0,1,2,3,4)
        Object.keys(this.workOrderTermEnums).forEach((key) => {
          if (Number(key) != 5) delete this.workOrderTermEnums[Number(key)];
        });
        break;
      case 6:
        //GreigeOnly: keep only CommissionKnitting, FullKnitting (delete 2,3,4,5)
        Object.keys(this.workOrderTermEnums).forEach((key) => {
          if (Number(key) == 2 || Number(key) == 3 || Number(key) == 4 || Number(key) == 5) delete this.workOrderTermEnums[Number(key)];
        });
        break;
    }
  }

  getWorkOrderById(id: string, isCopy = false, isShortFall = false) {
    this.workOrderProxyService.getWorkOrderById(id).subscribe({
      next: (response) => {
        this.workOrder = Array.isArray(response.data) ? response.data[0] : response.data;
        this.notes = this.workOrder?.notes ?? [];
        if (this.workOrder) {
          this.breadcrumbService.setCurrent(isCopy ? 'Common_New' : this.workOrder.orderNumber);
          this.filterTermsBasedOnOrderType(this.workOrder.orderType);
          // Populate the forms with the fetched data
          this.populateData(this.workOrder, isCopy, isShortFall);
          // validate that is short fall
          const parentWorkOderValidation = this.workOrder && this.workOrder.parentBulkWorkOrder;

          if (parentWorkOderValidation) {
            this.isShortFall = true;
          }
        }
        this.isLoading = 0;
      },
      error: (err) => {
        console.error('Error fetching work order:', err);
        this.isLoading = 0;
      },
    });
  }

  // Called when a work order is loaded to patch the form values

  private populateData(workOrder: WorkOrder, isCopy = false, isShortFall = false): void {
    const disableEverything = !this.getShowSaveButton();
    // this.isLoading++;

    if (isCopy) {
      this.status.setValue(0);
      this.workOrder = null;
    } else {
      this.status.setValue(workOrder.status);
    }
    this.orderType = workOrder.orderType;
    // this.greigeWorkOrderToUse.disable();
    this.specificWorkOrderGreige.disable();

    const isColorLessOrderType =
      workOrder.orderType === WorkOrderType.GreigeStockForDyeing ||
      workOrder.orderType === WorkOrderType.GreigeOnly ||
      workOrder.orderType === WorkOrderType.BGrade;

    // orderDetailsForm
    this.notes = isCopy ? [] : workOrder.notes;

    if (workOrder.customerReference === workOrder.billingToReference) {
      this.billingSameAsClient.setValue(true);
    }

    if (workOrder.shippingToReference === workOrder.billingToReference && workOrder.shippingAddressCode === workOrder.billingAddressCode) {
      this.shippingSameAsBilling.setValue(true);
    }
    // orderDetailsForm
    this.orderDetailsForm.patchValue({
      id: isCopy ? null : workOrder.id,
      orderType: isShortFall ? 3 : workOrder.orderType,
      workOrderTerm: workOrder.workOrderTerm,
      uom: workOrder.uom,
      customerReference: workOrder.customerReference,
      customer: workOrder.customer,
      negotiatiedLeadTimeInWeeks: workOrder.negotiatiedLeadTimeInWeeks,
      orderReceivedDate: new Date(workOrder.orderReceivedDate),
      actualShipmentDate: new Date(workOrder.actualShipmentDate),
      shipmentType: workOrder.shipmentType,
      brandReference: workOrder.brandReference,
      brand: workOrder.brand,
      shippingTo: workOrder.shippingTo,
      shippingAddressCode: workOrder.shippingAddressCode,
      billingTo: workOrder.billingTo,
      billingAddressCode: workOrder.billingAddressCode,
      paymentTermsClientCode: workOrder.paymentTermsClientCode,
      specificWorkOrderGreigeReference: workOrder.specificWorkOrderGreigeReference,
      yarnOrigin: workOrder.yarnOrigin,
    });

    if (!workOrder.billingTo && workOrder.billingToReference) {
      this.loadBillingToBusiness(workOrder.billingToReference, workOrder.billingAddressCode);
    }

    if (!workOrder.shippingTo && workOrder.shippingToReference) {
      this.loadShippingToBusiness(workOrder.shippingToReference, workOrder.shippingAddressCode);
    }

    this.yarnLatestReceptionDate.setValue(
      workOrder.estimatedDatesPlanning?.yarnLatestReceptionDate ? new Date(workOrder.estimatedDatesPlanning.yarnLatestReceptionDate) : null,
    );
    this.knittingLatestStartDate.setValue(
      workOrder.estimatedDatesPlanning?.knittingLatestStartDate ? new Date(workOrder.estimatedDatesPlanning.knittingLatestStartDate) : null,
    );
    this.knittingEstimatedEndDate.setValue(
      workOrder.estimatedDatesPlanning?.knittingEstimatedEndDate
        ? new Date(workOrder.estimatedDatesPlanning.knittingEstimatedEndDate)
        : null,
    );
    this.dyeingLatestStartDate.setValue(
      workOrder.estimatedDatesPlanning?.dyeingLatestStartDate ? new Date(workOrder.estimatedDatesPlanning.dyeingLatestStartDate) : null,
    );
    this.dyeingEstimatedEndDate.setValue(
      workOrder.estimatedDatesPlanning?.dyeingEstimatedEndDate ? new Date(workOrder.estimatedDatesPlanning.dyeingEstimatedEndDate) : null,
    );
    this.finishingLatestStartDate.setValue(
      workOrder.estimatedDatesPlanning?.finishingLatestStartDate
        ? new Date(workOrder.estimatedDatesPlanning.finishingLatestStartDate)
        : null,
    );
    this.finishingEstimatedEndDate.setValue(
      workOrder.estimatedDatesPlanning?.finishingEstimatedEndDate
        ? new Date(workOrder.estimatedDatesPlanning.finishingEstimatedEndDate)
        : null,
    );
    this.promisedShipmentDate.setValue(workOrder.promisedShipmentDate ? new Date(workOrder.promisedShipmentDate) : null);
    // orderAuditTrailForm
    if (!isCopy) {
      this.orderAuditTrailForm.patchValue({
        createdBy: workOrder.createdBy,
        createdDate: workOrder.createdDate ? new Date(workOrder.createdDate.toString()) : null,
        modifiedBy: workOrder.modifiedBy,
        modifiedDate: workOrder.modifiedDate ? new Date(workOrder.modifiedDate.toString()) : null,
      });
    }

    if (isShortFall && workOrder.customerProductOrders && workOrder.customerProductOrders.length > 0) {
      console.log('Auto-populating customer product orders from parent work order for Short Fall:', workOrder.customerProductOrders.length);
      this.customerProductOrders = [...workOrder.customerProductOrders];
    } else {
      this.customerProductOrders = isShortFall ? [] : workOrder.customerProductOrders;
    }

    if (!workOrder.brand && workOrder.brandReference.length > 0) {
      this.getBrandById(workOrder.brandReference);
    }
    // getLinkedWorkOrder
    if (workOrder.orderType === WorkOrderType.Linked && workOrder.specificWorkOrderGreigeReference?.length > 0) {
      this.getLinkedWorkOrder(workOrder.specificWorkOrderGreigeReference);
    }
    // set planningEstimatedYW and estimatedShipmentDate
    // Set week numbers BEFORE patching form so the dateFormat binding has the correct value
    if (workOrder.planningEstimatedYW?.week) {
      this.planningEstimatedWeekNumber = workOrder.planningEstimatedYW.week;
    }
    if (workOrder.estimatedShipmentDate) {
      this.estimatedShipmentWeekNumber = this.getDateWeek(new Date(workOrder.estimatedShipmentDate));
    }

    this.orderDetailsForm.patchValue({
      planningEstimatedYW: this.getDateFromWeek(workOrder.planningEstimatedYW),
      estimatedShipmentDate: new Date(workOrder.estimatedShipmentDate),
    });

    if (workOrder.orderType === WorkOrderType.Linked) {
      this.orderDetailsForm.get('uom')!.disable();
      this.orderDetailsForm.get('brand')!.disable();
    }
    this.setEstimatedDates('planningEstimated');
    this.setEstimatedDates('estimatedShipment');

    this.workOrderFabricFormArrays.clear();

    if (isShortFall && workOrder.fabrics && workOrder.fabrics.length > 0) {
      console.log('Auto-populating all fabrics from parent work order for Short Fall:', workOrder.fabrics.length);

      workOrder.fabrics.forEach((parentFabric) => {
        const garmetDetailsArray = !_.isNil(parentFabric.garmetDetails)
          ? new FormArray<FormGroup<GarmentDetailForm>>(
              parentFabric.garmetDetails.map((garmetDetail) =>
                this.fb.group<GarmentDetailForm>({
                  colorReference: new FormControl(garmetDetail.colorReference, { nonNullable: true }),
                  quantity: this.fb.control(0, {
                    // Cantidad en 0 para shortfall
                    validators: [Validators.required, Validators.min(0.01)],
                    nonNullable: true,
                  }),
                  productOrderNumber: new FormControl(garmetDetail.productOrderNumber || null, {
                    nonNullable: true,
                    validators: [Validators.required],
                  }),
                  unitPrice: new FormControl(garmetDetail.unitPrice ?? parentFabric.unitPrice ?? 0, {
                    validators: [Validators.required, Validators.min(0.01)],
                    nonNullable: true,
                  }),
                }),
              ),
            )
          : new FormArray<FormGroup<GarmentDetailForm>>([]);

        const yarnCertificationDetailsArray = !_.isNil(parentFabric.yarnCertificationDetails)
          ? new FormArray<FormGroup<YarnCertificationDetailsForm>>(
              parentFabric.yarnCertificationDetails.map((certDetail) =>
                this.fb.group<YarnCertificationDetailsForm>({
                  yarnCode: new FormControl(certDetail.yarnCode, { nonNullable: true }),
                  certificationReferences: new FormControl(certDetail.certificationReferences || [], { nonNullable: true }),
                }),
              ),
            )
          : new FormArray<FormGroup<YarnCertificationDetailsForm>>([]);

        const fabricForm = new FormGroup<WorkOrderFabricFormGroup>({
          fabricCode: new FormControl(parentFabric.fabricCode, { validators: [Validators.required], nonNullable: true }),
          fabric: new FormControl(parentFabric.fabric),
          packingType: new FormControl(parentFabric.packingType, { validators: [Validators.required], nonNullable: true }),
          clientRequestedFabricLabelCode: new FormControl(parentFabric.clientRequestedFabricLabelCode || null),
          unitPrice: new FormControl(parentFabric.garmetDetails?.find((g) => !_.isNil(g.unitPrice) && g.unitPrice > 0)?.unitPrice ?? 0, {
            validators: [Validators.required, Validators.min(0.01)],
            nonNullable: true,
          }),
          garmetPart: new FormControl(parentFabric.garmetPart, { validators: [Validators.required], nonNullable: true }),
          quantityInUOM: new FormControl(0, {
            // Cantidad en 0 para shortfall
            validators: [Validators.required, Validators.min(0.01)],
            nonNullable: true,
          }),
          garmetDetails: garmetDetailsArray,
          yarnCertificationDetails: yarnCertificationDetailsArray,
          aliasReference: new FormControl(parentFabric.aliasReference || null, { nonNullable: true }),
          productOrderNumber: new FormControl(parentFabric.productOrderNumber || null, { nonNullable: true }),
        });
        if (!isColorLessOrderType) {
          fabricForm.controls.unitPrice.disable();
        }
        this.workOrderFabricFormArrays.push(fabricForm);
      });
    } else if (isCopy && workOrder.fabrics && workOrder.fabrics.length > 0) {
      console.log('Copying fabrics from original work order:', workOrder.fabrics.length);

      workOrder.fabrics.forEach((fabric) => {
        const garmetDetailsArray = !_.isNil(fabric.garmetDetails)
          ? new FormArray<FormGroup<GarmentDetailForm>>(
              fabric.garmetDetails.map((garmetDetail) =>
                this.fb.group<GarmentDetailForm>({
                  colorReference: new FormControl(garmetDetail.colorReference, { nonNullable: true }),
                  quantity: this.fb.control(garmetDetail.quantity, {
                    validators: [Validators.required, Validators.min(0.01)],
                    nonNullable: true,
                  }),
                  productOrderNumber: new FormControl(garmetDetail.productOrderNumber || null, {
                    nonNullable: true,
                    validators: [Validators.required],
                  }),
                  unitPrice: new FormControl(garmetDetail.unitPrice ?? fabric.unitPrice ?? 0, {
                    validators: [Validators.required, Validators.min(0.01)],
                    nonNullable: true,
                  }),
                }),
              ),
            )
          : new FormArray<FormGroup<GarmentDetailForm>>([]);

        const yarnCertificationDetailsArray = !_.isNil(fabric.yarnCertificationDetails)
          ? new FormArray<FormGroup<YarnCertificationDetailsForm>>(
              fabric.fabric?.greige?.yarnDetails.map((yarnDetails) =>
                this.fb.group<YarnCertificationDetailsForm>({
                  yarnCode: new FormControl(yarnDetails.yarnCode!, { nonNullable: true }),
                  certificationReferences: new FormControl(
                    fabric.yarnCertificationDetails?.find((yc) => yc.yarnCode === yarnDetails.yarnCode)?.certificationReferences || [],
                    { nonNullable: true },
                  ),
                }),
              ),
            )
          : new FormArray<FormGroup<YarnCertificationDetailsForm>>(
              fabric.fabric?.greige?.yarnDetails.map((yarnDetails) =>
                this.fb.group<YarnCertificationDetailsForm>({
                  yarnCode: new FormControl(yarnDetails.yarnCode!, { nonNullable: true }),
                  certificationReferences: new FormControl([], { nonNullable: true }),
                }),
              ),
            );

        const fabricForm = new FormGroup<WorkOrderFabricFormGroup>({
          fabricCode: new FormControl(fabric.fabricCode, { validators: [Validators.required], nonNullable: true }),
          fabric: new FormControl(fabric.fabric),
          packingType: new FormControl(fabric.packingType, { validators: [Validators.required], nonNullable: true }),
          clientRequestedFabricLabelCode: new FormControl(fabric.clientRequestedFabricLabelCode || null),
          unitPrice: new FormControl(
            fabric.unitPrice ?? fabric.garmetDetails?.find((g) => !_.isNil(g.unitPrice) && g.unitPrice > 0)?.unitPrice ?? 0,
            { validators: [Validators.required, Validators.min(0.01)], nonNullable: true },
          ),
          garmetPart: new FormControl(fabric.garmetPart, { validators: [Validators.required], nonNullable: true }),
          quantityInUOM: new FormControl(fabric.quantityInUOM, {
            validators: [Validators.required, Validators.min(0.01)],
            nonNullable: true,
          }),
          garmetDetails: garmetDetailsArray,
          yarnCertificationDetails: yarnCertificationDetailsArray,
          aliasReference: new FormControl(fabric.aliasReference || null, { nonNullable: true }),
          productOrderNumber: new FormControl(fabric.productOrderNumber || null, { nonNullable: true }),
        });

        if (!isColorLessOrderType) {
          fabricForm.controls.unitPrice.disable();
        }
        this.workOrderFabricFormArrays.push(fabricForm);
      });
    }

    // Lógica normal para no Short Fall
    else if (!isShortFall && !isCopy) {
      workOrder.fabrics.forEach((fabric) => {
        const garmetDetailsArray = !_.isNil(fabric.garmetDetails)
          ? new FormArray<FormGroup<GarmentDetailForm>>(
              fabric.garmetDetails.map((garmetDetail) =>
                this.fb.group<GarmentDetailForm>({
                  colorReference: new FormControl(garmetDetail.colorReference, { nonNullable: true }),
                  quantity: this.fb.control(garmetDetail.quantity, {
                    validators: [Validators.required, Validators.min(0.01)],
                    nonNullable: true,
                  }),
                  productOrderNumber: new FormControl(garmetDetail.productOrderNumber || null, {
                    nonNullable: true,
                    validators: [Validators.required],
                  }),
                  unitPrice: new FormControl(garmetDetail.unitPrice ?? fabric.unitPrice ?? 0, {
                    validators: [Validators.required, Validators.min(0.01)],
                    nonNullable: true,
                  }),
                }),
              ),
            )
          : new FormArray<FormGroup<GarmentDetailForm>>([]);

        const yarnCertificationDetailsArray = !_.isNil(fabric.yarnCertificationDetails)
          ? new FormArray<FormGroup<YarnCertificationDetailsForm>>(
              fabric.fabric?.greige?.yarnDetails.map((yarnDetails) =>
                this.fb.group<YarnCertificationDetailsForm>({
                  yarnCode: new FormControl(yarnDetails.yarnCode!, { nonNullable: true }),
                  certificationReferences: new FormControl(
                    fabric.yarnCertificationDetails?.find((yc) => yc.yarnCode === yarnDetails.yarnCode)?.certificationReferences || [],
                    { nonNullable: true },
                  ),
                }),
              ),
            )
          : new FormArray<FormGroup<YarnCertificationDetailsForm>>(
              fabric.fabric?.greige?.yarnDetails.map((yarnDetails) =>
                this.fb.group<YarnCertificationDetailsForm>({
                  yarnCode: new FormControl(yarnDetails.yarnCode!, { nonNullable: true }),
                  certificationReferences: new FormControl([], { nonNullable: true }),
                }),
              ),
            );

        const fabricForm = new FormGroup<WorkOrderFabricFormGroup>({
          fabricCode: new FormControl(fabric.fabricCode, { validators: [Validators.required], nonNullable: true }),
          fabric: new FormControl(fabric.fabric),
          packingType: new FormControl(fabric.packingType, { validators: [Validators.required], nonNullable: true }),
          clientRequestedFabricLabelCode: new FormControl(fabric.clientRequestedFabricLabelCode || null),
          unitPrice: new FormControl(
            fabric.unitPrice ?? fabric.garmetDetails?.find((g) => !_.isNil(g.unitPrice) && g.unitPrice > 0)?.unitPrice ?? 0,
            { validators: [Validators.required, Validators.min(0.01)], nonNullable: true },
          ),
          garmetPart: new FormControl(fabric.garmetPart, { validators: [Validators.required], nonNullable: true }),
          quantityInUOM: new FormControl(fabric.quantityInUOM, {
            validators: [Validators.required, Validators.min(0.01)],
            nonNullable: true,
          }),
          garmetDetails: garmetDetailsArray,
          yarnCertificationDetails: yarnCertificationDetailsArray,
          aliasReference: new FormControl(fabric.aliasReference || null, { nonNullable: true }),
          productOrderNumber: new FormControl(fabric.productOrderNumber || null, { nonNullable: true }),
        });

        if (!isColorLessOrderType) {
          fabricForm.controls.unitPrice.disable();
        }
        this.workOrderFabricFormArrays.push(fabricForm);
      });
    }

    if (workOrder.orderType === WorkOrderType.Sample) {
      workOrder.fabrics.forEach((fabric) => {
        if (fabric.garmetDetails?.length) {
          this.labDipRequestProxyService.getColorByFabric({ fabricCode: fabric.fabricCode }).subscribe({
            next: (response) => {
              const colors = response.data ?? [];
              colors.forEach((color) => {
                if (!this.customerColors.find((c) => c.id === color.id)) {
                  this.customerColors.push(color);
                }
              });
            },
          });
        }
      });
    }

    if (isShortFall) {
      this.status.setValue(0);
    }

    if ((disableEverything && !isCopy) || workOrder.parentBulkWorkOrder) {
      this.orderDetailsForm.disable();
      // Para Short Fall, NO deshabilitar los fabrics para que el usuario pueda editar cantidades
      if (!isShortFall) {
        this.workOrderFabricFormArrays.disable();
      }
      this.productOrderNumber.disable();
      this.clientOrderReference.disable();
      this.productOrderNumberDateReceived.disable();
      this.billingSameAsClient.disable();
      this.totalFabricQuantity.disable();
      this.totalYarnQuantity.disable();
      this.promisedShipmentDate.disable();
      this.specificWorkOrderGreige.disable();
      this.shippingSameAsBilling.disable();
    }

    if (isShortFall || workOrder.parentBulkWorkOrder) {
      this.workOrderFabricFormArrays.enable();
    }

    this.isUpdatingFromServer.set(false);

    // this.isLoading--;
  }

  setEstimatedDates(inputRef: 'planningEstimated' | 'estimatedShipment') {
    // get week number for planningEstimatedInput or estimatedShipmentInput
    const dateValue = this.orderDetailsForm.value[`${inputRef}YW`];
    if (dateValue) {
      this[`${inputRef}WeekNumber`] = this.getDateWeek(dateValue);
    }
    this.cRef.detectChanges();
    // refresh planningEstimatedInput or estimatedShipmentInput calendar panel value
    if (this[`${inputRef}Input`]?.inputfieldViewChild) {
      this[`${inputRef}Input`].inputfieldViewChild?.nativeElement.focus({
        preventScroll: true,
      });
      this[`${inputRef}Input`].inputfieldViewChild?.nativeElement.blur();
      this[`${inputRef}Input`].overlayVisible = false;
    }
  }

  addCustomerProductOrder() {
    if (this.productOrderNumber.value != '') {
      this.customerProductOrders.push({
        productOrderNumber: this.productOrderNumber.value!,
        clientOrderReference: this.clientOrderReference.value!,
        dateReceived: this.productOrderNumberDateReceived.value!.toISOString(),
      });
      this.productOrderNumber.setValue('');
      this.clientOrderReference.setValue('');
      this.productOrderNumberDateReceived.setValue(null);
    }
  }

  deleteCustomerProductOrder(index: number) {
    if (index > -1) {
      const productOrder = this.customerProductOrders[index];
      const fabricsUsingThisOrder = this.workOrderFabricFormArrays.value.filter(
        (fabric) =>
          fabric?.garmetDetails?.some((detail) => detail.productOrderNumber === productOrder.productOrderNumber) ||
          fabric?.productOrderNumber === productOrder.productOrderNumber,
      );
      if (fabricsUsingThisOrder.length === 0) {
        // only splice array when item is found
        this.customerProductOrders.splice(index, 1); // 2nd parameter means remove one item only
      } else {
        GlobalMessageUtil.warn('Cannot delete product order', 'This product order is being used by one or more fabrics.');
      }
    }
  }

  public getBillingAddresses() {
    if (this.billingSameAsClient.value) {
      return (
        this.orderDetailsForm.value.customer?.addresses?.map((address: Address) => ({
          ...address,
          fieldToDisplay: `${address.code}, ${address.address1} ${address.city}, ${address.zipCode}`,
        })) ?? []
      );
    } else {
      return (
        this.orderDetailsForm.value.billingTo?.addresses?.map((address: Address) => ({
          ...address,
          fieldToDisplay: `${address.code}, ${address.address1} ${address.city}, ${address.zipCode}`,
        })) ?? []
      );
    }
  }

  public greigeWorkOrderTypeAhead(event: AutoCompleteCompleteEvent): void {
    const term = event.query.toLowerCase().trim();
    const searchCommand: WorkOrderSearchCommand = {
      orderType: 2,
      orderNumber: term,
    };

    this.workOrderProxyService.searchWorkOrder(searchCommand, 1, 10).subscribe({
      next: (response) => {
        this.greigeWorkOrderSuggestions = response.data?.items ?? [];
      },
      error: (error) => {
        console.error('Error fetching greige work orders:', error);
        this.greigeWorkOrderSuggestions = [];
      },
    });
  }

  get fabricSearchStatuses(): ProductDevelopmentStatus[] {
    if (this.orderType === WorkOrderType.Sample) {
      return [
        ProductDevelopmentStatus.InDevelopment,
        ProductDevelopmentStatus.UnderReview,
        ProductDevelopmentStatus.Approved,
        ProductDevelopmentStatus.ReadyForProduction,
      ];
    }
    return [ProductDevelopmentStatus.ReadyForProduction];
  }

  public fabricsTypeAhead(event: AutoCompleteCompleteEvent): void {
    const term = event.query.toLowerCase().trim();

    this.fabricProxyService.searchFabric({ longDescription: term, fabricCode: term, status: this.fabricSearchStatuses }, true).subscribe({
      next: (response) => {
        if (response.data && response.data?.items?.length > 0) {
          this.filteredFabrics = response.data.items
            .filter((f) => {
              return !this.workOrderFabricFormArrays.value.some((wof) => wof.fabricCode?.toLowerCase() === f.fabricCode.toLowerCase());
            })
            .map((fabric) => {
              fabric.fieldToDisplay = `(${fabric.fabricCode}) ${fabric.longDescription}`;
              return fabric;
            });
        } else {
          this.filteredFabrics = [];
        }
      },
      error: (e) => {
        console.error(e);
        this.filteredFabrics = [];
      },
    });
  }

  onSelectFabric(event: AutoCompleteSelectEvent) {
    console.log(event);
    this.addFabricAtList(event.value);
  }

  private addFabricAtList(fabric: Fabric | string): void {
    if (typeof fabric === 'string') return;
    const matchFabric = this.workOrderFabricFormArrays.value.find((fab) => fab.fabricCode === fabric.fabricCode);
    if (matchFabric && !this.isShortFall) return;

    // Para Short Fall, buscar el fabric COMPLETO del padre
    let parentFabric: WorkOrderFabric | undefined;
    if (this.isShortFall && this.workOrder?.fabrics) {
      parentFabric = this.workOrder.fabrics.find((f) => f.fabricCode === fabric.fabricCode);
    }

    const isColorLessOrderType =
      this.orderType === WorkOrderType.GreigeStockForDyeing ||
      this.orderType === WorkOrderType.GreigeOnly ||
      this.orderType === WorkOrderType.BGrade;

    // Si es Short Fall y encontramos el fabric padre, clonarlo completamente
    if (this.isShortFall && parentFabric) {
      // Crear garmentDetails array - clonar EXACTAMENTE del padre
      const garmetDetailsArray = !_.isNil(parentFabric.garmetDetails)
        ? new FormArray<FormGroup<GarmentDetailForm>>(
            parentFabric.garmetDetails.map((garmetDetail) =>
              this.fb.group<GarmentDetailForm>({
                colorReference: new FormControl(garmetDetail.colorReference, { nonNullable: true }),
                quantity: this.fb.control(0, {
                  // Mantener misma cantidad del padre
                  validators: [Validators.required, Validators.min(0.01)],
                  nonNullable: true,
                }),
                productOrderNumber: new FormControl(garmetDetail.productOrderNumber || null, {
                  nonNullable: true,
                  validators: [Validators.required],
                }),
                unitPrice: new FormControl(garmetDetail.unitPrice ?? parentFabric?.unitPrice ?? 0, {
                  validators: [Validators.required, Validators.min(0.01)],
                  nonNullable: true,
                }),
              }),
            ),
          )
        : new FormArray<FormGroup<GarmentDetailForm>>([]);

      // Crear yarnCertificationDetails array - clonar EXACTAMENTE del padre
      const yarnCertificationDetailsArray = !_.isNil(parentFabric.yarnCertificationDetails)
        ? new FormArray<FormGroup<YarnCertificationDetailsForm>>(
            parentFabric.yarnCertificationDetails.map((certDetail) =>
              this.fb.group<YarnCertificationDetailsForm>({
                yarnCode: new FormControl(certDetail.yarnCode, { nonNullable: true }),
                certificationReferences: new FormControl(certDetail.certificationReferences || [], { nonNullable: true }),
              }),
            ),
          )
        : new FormArray<FormGroup<YarnCertificationDetailsForm>>([]);

      const shortFallFabricForm = this.fb.group<WorkOrderFabricFormGroup>({
        fabricCode: new FormControl(parentFabric.fabricCode, { nonNullable: true }),
        fabric: new FormControl(parentFabric.fabric, { nonNullable: true }),
        packingType: new FormControl(parentFabric.packingType, { validators: [Validators.required], nonNullable: true }),
        clientRequestedFabricLabelCode: new FormControl(parentFabric.clientRequestedFabricLabelCode || null),
        unitPrice: new FormControl(parentFabric.garmetDetails?.find((g) => !_.isNil(g.unitPrice) && g.unitPrice > 0)?.unitPrice ?? 0, {
          validators: [Validators.required, Validators.min(0.01)],
          nonNullable: true,
        }),
        quantityInUOM: new FormControl(0, {
          validators: [Validators.required, Validators.min(0.01)],
          nonNullable: true,
        }),
        garmetPart: new FormControl(parentFabric.garmetPart, { validators: [Validators.required] }),
        garmetDetails: garmetDetailsArray,
        aliasReference: new FormControl(parentFabric.aliasReference || null, { nonNullable: true }),
        productOrderNumber: new FormControl(parentFabric.productOrderNumber || null, { nonNullable: true }),
        yarnCertificationDetails: yarnCertificationDetailsArray,
      });
      if (!isColorLessOrderType) {
        shortFallFabricForm.controls.unitPrice.disable();
      }
      this.workOrderFabricFormArrays.push(shortFallFabricForm);
    } else {
      const newFabricForm = this.fb.group<WorkOrderFabricFormGroup>({
        fabricCode: new FormControl(fabric.fabricCode, { nonNullable: true }),
        fabric: new FormControl(fabric, { nonNullable: true }),
        packingType: new FormControl<number | null>(null, { validators: [Validators.required] }),
        clientRequestedFabricLabelCode: new FormControl<string | null>(null),
        unitPrice: new FormControl(0, { validators: [Validators.required, Validators.min(0.01)], nonNullable: true }),
        quantityInUOM: new FormControl(0, { validators: [Validators.required, Validators.min(0.01)], nonNullable: true }),
        garmetPart: new FormControl(null, { validators: [Validators.required] }),
        garmetDetails: new FormArray<FormGroup<GarmentDetailForm>>([]),
        aliasReference: new FormControl<string | null>(null, { nonNullable: true }),
        productOrderNumber: new FormControl<string | null>(null, { nonNullable: true }),
        yarnCertificationDetails: new FormArray<FormGroup<YarnCertificationDetailsForm>>(
          fabric.greige.yarnDetails.map((yarnDetails) =>
            this.fb.group<YarnCertificationDetailsForm>({
              yarnCode: new FormControl(yarnDetails.yarnCode, { nonNullable: true }),
              certificationReferences: new FormControl([], { nonNullable: true }),
            }),
          ),
        ),
      });
      if (!isColorLessOrderType) {
        newFabricForm.controls.unitPrice.disable();
      }
      this.workOrderFabricFormArrays.push(newFabricForm);
    }
  }

  public removeFabricAtList(id: string): void {
    //remove the formgroup from workOrderFabricFormArrays
    const index = this.workOrderFabricFormArrays.controls.findIndex((control) => control.get('fabricCode')?.value === id);
    if (index !== -1) {
      this.workOrderFabricFormArrays.removeAt(index);
    }
  }

  // Customer Logic //
  public customerTypeAhead(event: AutoCompleteCompleteEvent): void {
    const term = event.query.trim().toLowerCase();

    const searchCommand = {
      name: term,
      code: term,
      businessTypes: [BusinessEntityType.Client],
    };

    this.businessProxyService.search(searchCommand, true).subscribe({
      next: (response) => {
        const customers = response.data?.items ?? [];
        this.filteredCustomers = customers.filter((customer) => customer.name.toLowerCase().includes(term));
      },
      error: () => {
        this.filteredCustomers = [];
      },
    });
  }

  public shippingToTypeAhead(event: AutoCompleteCompleteEvent): void {
    const term = event.query.trim().toLowerCase();

    this.businessProxyService
      .search(
        {
          name: term,
          code: term,
          businessTypes: [BusinessEntityType.Client],
        },
        true,
      )
      .subscribe({
        next: (response) => {
          if (response.data?.items) {
            this.shippingToOptions = response.data.items.map((business) => ({
              ...business,
              fieldToDisplay: `(${business.code}) ${business.name}`,
            }));
          } else {
            this.shippingToOptions = [];
          }
        },
        error: () => {
          this.shippingToOptions = [];
        },
      });
  }

  public billingToTypeAhead(event: AutoCompleteCompleteEvent): void {
    const term = event.query.trim().toLowerCase();

    this.businessProxyService
      .search(
        {
          name: term,
          code: term,
          businessTypes: [BusinessEntityType.Client],
        },
        true,
      )
      .subscribe({
        next: (response) => {
          if (response.data && response.success) {
            this.billingToOptions = response.data.items.map((business) => ({
              ...business,
              fieldToDisplay: `(${business.code}) ${business.name}`,
            }));
          } else {
            this.billingToOptions = [];
          }
        },
        error: () => {
          this.billingToOptions = [];
        },
      });
  }

  canEditPackingTypeOnly(): boolean {
    return (
      AuthService.hasRole(WorkOrderRoles.WorkOrderAdmin) &&
      !_.isNil(this.workOrder?.id) &&
      !this.isCopyMode &&
      (this.workOrder?.status ?? 0) >= 2
    );
  }

  onSavePackingType(event: { fabricCode: string; packingType: number }): void {
    if (!this.workOrder?.id) return;
    this.isLoading++;
    this.workOrderProxyService
      .updatePackingType(this.workOrder.id, event)
      .pipe(finalize(() => this.isLoading--))
      .subscribe({
        next: () => GlobalMessageUtil.success('Work Order', 'Packing type updated'),
      });
  }

  getShowSaveButton(): boolean {
    if (!this.canEdit()) {
      return false;
    }
    if (_.isNil(this.workOrder?.id)) {
      return true;
    } else if (this.workOrder?.status < 2) {
      return true;
    }
    return false;
  }

  selectCustomer(event: AutoCompleteSelectEvent) {
    this.orderDetailsForm.patchValue({ customer: event.value, customerReference: event.value.id });
    if (this.billingSameAsClient.value) this.applyPaymentTermsFromBilling();
  }

  selectBillingTo(event: AutoCompleteSelectEvent) {
    this.orderDetailsForm.patchValue({ billingTo: event.value });
    this.applyPaymentTermsFromBilling();
  }

  // Fired only by the user toggling the "Same as Client" checkbox — never by programmatic setValue calls
  // (e.g. populateData loading a saved work order), so it can't clobber the work order's own paymentTermsClientCode.
  onBillingSameAsClientToggle(): void {
    this.applyPaymentTermsFromBilling();
  }

  // Auto-fill the (disabled) payment terms from the active billing business's client details.
  // Bill To drives it; falls back to the Customer when "Same as Client" is checked. Clears if none configured.
  private applyPaymentTermsFromBilling(): void {
    const billingBusiness = this.billingSameAsClient.value ? this.orderDetailsForm.value.customer : this.orderDetailsForm.value.billingTo;
    this.orderDetailsForm.get('paymentTermsClientCode')?.patchValue(billingBusiness?.clientDetails?.paymentTermsCode ?? null);
  }

  // Address Logic //
  public addressTypeAhead(event: AutoCompleteCompleteEvent): void {
    const term = event.query.trim().toLowerCase();
    let allAddresses = this.orderDetailsForm.value.customer.addresses ?? [];
    allAddresses = allAddresses.map((address: Address) => {
      address.fieldToDisplay = `(${address.code}) ${address.address1} ${address.address2} ${address.city} ${address.zipCode} ${address.country}`;
      return address;
    });
    if (!term) {
      this.filteredAddresses = allAddresses;
      return;
    }

    this.filteredAddresses = allAddresses.filter((address: Address) =>
      `${address.address1} ${address.address2} ${address.city} ${address.zipCode} ${address.country}`.toLowerCase().includes(term),
    );
  }

  // Brand Logic //
  public brandTypeAhead(event: AutoCompleteCompleteEvent): void {
    const term = event.query.trim().toLowerCase();

    const searchCommand = {
      businessTypes: [BusinessEntityType.Brand],
      name: term,
      code: term,
    };

    this.businessProxyService.search(searchCommand, true).subscribe({
      next: (response) => {
        if (!response.data?.items || response.data.items.length === 0) {
          this.filteredBrands = [];
          return;
        }
        const brands = response.data.items;
        this.filteredBrands = brands.map((brand) => ({
          ...brand,
          fieldToDisplay: `(${brand.code}) ${brand.name}`,
        }));
      },
      error: (err) => {
        console.error(err);
        this.filteredBrands = [];
      },
    });
  }

  getBrandById(id: string) {
    this.businessProxyService.getById(id).subscribe({
      next: (response) => {
        const brand = response.data;
        if (brand) {
          this.orderDetailsForm.patchValue({ brand: brand });
        }
      },
    });
  }

  selectBrand(event: AutoCompleteSelectEvent) {
    this.orderDetailsForm.patchValue({ brand: event.value, brandReference: event.value.id });
  }

  getLinkedWorkOrder(id: string) {
    this.workOrderProxyService.getWorkOrderById(id).subscribe({
      next: (response) => {
        const linkedOrder = response.data;
        if (linkedOrder) {
          this.specificWorkOrderGreige.setValue(linkedOrder);
        }
      },
      error: (e) => {
        console.error('Error fetching linked work order:', e);
      },
    });
  }

  public save(): void {
    this.orderDetailsFormSubmitted = true;

    if (this.customerProductOrders.length === 0 && !this.isShortFall) {
      GlobalMessageUtil.error('Error', 'At least one Customer product Order must be added before saving.');
      return;
    }

    const formValues = this.orderDetailsForm.getRawValue();
    const billingTo = this.billingSameAsClient.value ? this.orderDetailsForm.value.customer : this.orderDetailsForm.value.billingTo;

    const shouldProceed = this.orderDetailsForm.disabled
      ? this.workOrderFabricFormArrays.valid // Solo validar fabrics si el form principal está disabled
      : this.orderDetailsForm.valid && this.workOrderFabricFormArrays.valid; // Validar ambos si está enabled

    if (shouldProceed) {
      // Clear garmetDetails if orderType doesn't allow colors (GreigeStockForDyeing or GreigeOnly)
      const orderTypeValue = this.orderDetailsForm.getRawValue().orderType;
      if (orderTypeValue === WorkOrderType.GreigeStockForDyeing || orderTypeValue === WorkOrderType.GreigeOnly) {
        this.workOrderFabricFormArrays.controls.forEach((fabricForm) => {
          fabricForm.controls.garmetDetails.clear();
        });
      }

      const dataForSend: WorkOrder = {
        ...this.orderDetailsForm.getRawValue(),
        id: this.isShortFall && !this.workOrder?.parentBulkWorkOrder ? undefined : this.workOrder?.id,
        specificWorkOrderGreigeReference: this.specificWorkOrderGreige.value?.id ?? this.workOrder?.specificWorkOrderGreigeReference,
        billingToReference: billingTo?.id ?? undefined,
        billingAddressCode: this.billingSameAsClient.value
          ? formValues.customer?.addresses?.find((addr: Address) => addr.addressTypes.includes(0))?.code
          : formValues.billingAddressCode,
        shippingToReference: this.shippingSameAsBilling.value ? billingTo?.id : (this.orderDetailsForm.value.shippingTo?.id ?? undefined),
        shippingAddressCode: this.shippingSameAsBilling.value
          ? this.billingSameAsClient.value
            ? formValues.customer?.addresses?.find((addr: Address) => addr.addressTypes.includes(1))?.code
            : formValues.billingAddressCode
          : formValues.shippingAddressCode,
        status: this.status.value,
        fabrics: this.workOrderFabricFormArrays.getRawValue(),
        orderReceivedDate: this.orderDetailsForm.value.orderReceivedDate.toISOString(),
        actualShipmentDate: this.orderDetailsForm.value.actualShipmentDate.toISOString(),
        customerProductOrders: this.customerProductOrders,
        notes: this.notes,
        planningEstimatedYW: this.orderDetailsForm.value.planningEstimatedYW
          ? {
              year: moment(this.orderDetailsForm.value.planningEstimatedYW).year(),
              week: this.getDateWeek(this.orderDetailsForm.value.planningEstimatedYW),
            }
          : null,
        estimatedShipmentDate: this.orderDetailsForm.value.estimatedShipmentDate?.toISOString() || undefined,
        promisedShipmentDate: this.promisedShipmentDate.value ? this.promisedShipmentDate.value.toISOString() : null,
        estimatedDatesPlanning: {
          yarnLatestReceptionDate: this.yarnLatestReceptionDate.value ? this.yarnLatestReceptionDate.value.toISOString() : null,
          knittingLatestStartDate: this.knittingLatestStartDate.value ? this.knittingLatestStartDate.value.toISOString() : null,
          knittingEstimatedEndDate: this.knittingEstimatedEndDate.value ? this.knittingEstimatedEndDate.value.toISOString() : null,
          dyeingLatestStartDate: this.dyeingLatestStartDate.value ? this.dyeingLatestStartDate.value.toISOString() : null,
          dyeingEstimatedEndDate: this.dyeingEstimatedEndDate.value ? this.dyeingEstimatedEndDate.value.toISOString() : null,
          FinishingLatestStartDate: this.finishingLatestStartDate.value ? this.finishingLatestStartDate.value.toISOString() : null,
          finishingEstimatedEndDate: this.finishingEstimatedEndDate.value ? this.finishingEstimatedEndDate.value.toISOString() : null,
        },
        parentBulkWorkOrder: this.workOrder?.parentBulkWorkOrder
          ? this.workOrder.parentBulkWorkOrder
          : this.isShortFall
            ? this.workOrder?.orderNumber
            : undefined,
      };
      if (_.isNil(dataForSend.negotiatiedLeadTimeInWeeks)) dataForSend.negotiatiedLeadTimeInWeeks = 0;

      if (dataForSend?.id) {
        this.isLoading++;
        this.workOrderProxyService.updateWorkOrder(dataForSend.id, dataForSend).subscribe({
          next: () => {
            this.router.navigate(['/work-orders']);
            this.isLoading--;
          },
          error: () => {
            this.isLoading--;
          },
        });
        // this.isLoading--;
      } else {
        this.isLoading++;
        this.workOrderProxyService
          .createWorkOrder(dataForSend)
          .pipe(
            finalize(() => {
              this.isLoading--;
            }),
          )
          .subscribe({
            next: (response) => {
              GlobalMessageUtil.success('Success', `Work Order ${response.data?.orderNumber} created successfully.`);
              this.router.navigate(['/work-orders']);
            },
          });
      }
      this.orderDetailsFormSubmitted = false;
    } else {
      if (this.workOrderFabricFormArrays.controls.length === 0) {
        GlobalMessageUtil.warn('No fabrics added', 'Please add at least one fabric to the work order before saving.');
        return;
      } else if (this.workOrderFabricFormArrays.controls.some((fabric) => (fabric.value.quantityInUOM ?? 0) <= 0)) {
        GlobalMessageUtil.warn('Invalid fabric quantity', 'Please ensure all fabrics have a valid quantity and/or colors before saving.');
        return;
      }

      GlobalMessageUtil.error('Error', 'Form has invalid fields. Please fill the required fields');
    }
  }

  setUomLabel(value: number) {
    this.selectedUomLabel = this.setOptionsForPrimeNg(this.unitOfMeasurementEnums).find((uom) => uom.value === value)?.label || '';
  }

  getDateWeek(date: Date): number {
    return moment(date).week();
  }

  getDateFromWeek(weekDate: YearWeek): Date {
    if (!weekDate) return new Date();
    const paddedWeek = String(weekDate.week).padStart(2, '0');
    const newDate = moment(`${weekDate.year}W${paddedWeek}`).toDate();
    return newDate;
  }

  cancel(): void {
    this.router.navigate(['/work-orders']);
  }

  clearAutocomplete(autoComplete: AutoComplete) {
    autoComplete.inputEL!.nativeElement.value = ''; // clear p-autocomplete visual
  }

  get isCopyMode(): boolean {
    return this.route.snapshot.queryParams['isCopy'] === 'true';
  }

  private loadBillingToBusiness(billingToReference: string, billingAddressCode?: number): void {
    this.businessProxyService.getById(billingToReference).subscribe({
      next: (response) => {
        const business = response.data;

        if (business) {
          const businessWithDisplay = {
            ...business,
            fieldToDisplay: `(${business.code}) ${business.name}`,
          };
          this.orderDetailsForm.patchValue({ billingTo: businessWithDisplay });
          if (!this.billingToOptions.find((b) => b.id === business.id)) {
            this.billingToOptions.push(businessWithDisplay);
          }
          if (billingAddressCode && business.addresses) {
            const selectedAddress = business.addresses.find(
              (addr) => addr.code === billingAddressCode && addr.addressTypes.includes(0), // 0 = Billing
            );

            if (selectedAddress) {
              this.orderDetailsForm.patchValue({
                billingAddressCode: selectedAddress.code,
              });
            }
          }

          this.cRef.detectChanges();
        }
      },
      error: (error) => {
        console.error('Error loading billing business:', error);
      },
    });
  }

  private loadShippingToBusiness(shippingToReference: string, shippingAddressCode?: number): void {
    this.businessProxyService.getById(shippingToReference).subscribe({
      next: (response) => {
        const business = response.data;

        if (business) {
          const businessWithDisplay = {
            ...business,
            fieldToDisplay: `(${business.code}) ${business.name}`,
          };
          this.orderDetailsForm.patchValue({ shippingTo: businessWithDisplay });

          if (!this.shippingToOptions.find((b) => b.id === business.id)) {
            this.shippingToOptions.push(businessWithDisplay);
          }

          if (shippingAddressCode && business.addresses) {
            const selectedAddress = business.addresses.find(
              (addr) => addr.code === shippingAddressCode && addr.addressTypes.includes(1), // 1 = Shipping
            );

            if (selectedAddress) {
              this.orderDetailsForm.patchValue({
                shippingAddressCode: selectedAddress.code,
              });
            }
          }

          this.cRef.detectChanges();
        }
      },
      error: (error) => {
        console.error('Error loading shipping business:', error);
      },
    });
  }

  public get workOrderStatusOptions(): EnumValues {
    if (!this.statusEnums || typeof this.statusEnums !== 'object') return {};
    let statuses = this.statusEnums;

    const showApproved = (this.workOrder?.status ?? 0) < 2;
    if (!showApproved) {
      //only show status > 0 for select
      statuses = Object.fromEntries(Object.entries(statuses).filter(([key]) => Number(key) > 2));
    }

    if (AuthService.hasRole(WorkOrderRoles.WorkOrderEditor) && !AuthService.hasRole(WorkOrderRoles.WorkOrderAdmin)) {
      const allowedValues = [0, 1];
      const filtered: EnumValues = {};

      for (const key of allowedValues) {
        if (statuses[key]) {
          filtered[key] = statuses[key];
        }
      }

      return filtered;
    }

    if (this.canEdit()) {
      return statuses;
    }

    return {};
  }

  goToInternalLink(): void {
    // Implement your navigation logic here
    window.open('https://scribehow.com/viewer/Creating_a_Work_Order_in_Sierra_ERP__Z5thH2A1RJWSEzMHKDjEUg');
  }

  onViewMore(): void {
    this.openNotesModal();
  }

  openNotesModal(): void {
    const modalData = {
      notes: this.notes,
      userLite: this.userLite,
      viewOnly: !this.canEdit(),
    };

    this.modalService.open(NotesSidebarComponent, {}, modalData).subscribe({
      next: (result) => {
        if (result && result.action === 'noteAdded') {
          this.notes = result.data.notes;
        }
      },
      error: (error) => {
        console.error('Error handling notes modal result:', error);
      },
    });
    setTimeout(() => {
      const modalElement = document.querySelector('.panel.modal') as HTMLElement;
      if (modalElement) modalElement.style.maxWidth = '50%';
      modalElement.style.width = '50%';
    }, 100);
  }

  fabricsSuggestionsShortFall: Fabric[] = [];

  public fabricsTypeAheadAvailableShortFall(): void {
    // this.fabricProxyService.searchFabric({ longDescription: term, fabricCode: term }, true).subscribe({
    //   next: (response) => {
    //     if (response.data && response.data.length > 0) {
    //       this.filteredFabrics = response.data
    //         .filter((f) => {
    //           return fabricsOfWorkOrder.includes(f.fabricCode);
    //         })
    //         .map((fabric) => {
    //           fabric.fieldToDisplay = `(${fabric.fabricCode}) ${fabric.longDescription}`;
    //           return fabric;
    //         });
    //     } else {
    //       this.filteredFabrics = [];
    //     }
    //   },
    //   error: (e) => {
    //     console.error(e);
    //     this.filteredFabrics = [];
    //   },
    // });

    this.fabricsSuggestionsShortFall = this.workOrder?.fabrics.map((f) => f.fabric) ?? [];

    this.fabricsSuggestionsShortFall.map((fabric) => {
      fabric.fieldToDisplay = `(${fabric.fabricCode}) ${fabric.longDescription}`;
      return fabric;
    });
  }
}
